import React, { useState, useEffect, useRef } from "react";
import { LocalOfferTwoTone } from "@material-ui/icons";
import { useSelector } from "react-redux";
import { flatten, uniq } from "lodash";
import { Select, Form } from "antd";

const TagsSelect = ({
  placeholder = "Select or type to add tags",
  formClass,
  showLabel = false,
}) => {
  const tagsRef = useRef(null);
  const tags = useSelector((state) => state.keywords.tags);

  const { Option } = Select;

  function handleChange(value) {
    setTimeout(() => {
      tagsRef.current.blur();
    }, 150);
  }

  return (
    <Form.Item name="tags" className={`mb-1 ${formClass}`}>
      <Select
        mode="tags"
        style={{ width: "100%", marginTop: showLabel && "10px" }}
        ref={tagsRef}
        onChange={handleChange}
        placeholder={
          <>
            <LocalOfferTwoTone className="mr-2 inputIcon" /> {placeholder}
          </>
        }
      >
        {tags.map((tag) => {
          return (
            <Option
              key={tag}
              value={tag}
              style={{ textTransform: "lowercase" }}
            >
              {tag}
            </Option>
          );
        })}
      </Select>
    </Form.Item>
  );
};

export default TagsSelect;
